import * as React from 'react'
import { Box, Card, CardContent, CardHeader } from '@mui/material'
import { PublishTree } from './tree/PublishTree'
import { useCurrentUserRedirectResource } from 'infrastructure/auth/auth.hooks'
import { TreeIdInput } from './tree/navigationHelpers/TreeNodeRouter'
import { useState } from 'react'
import { useGetTreeById } from 'shared/hooks/trees/hooks'

export function NewBundledCurricula() {
  const [treeIds, setTreeIds] = useState<{
    treeId?: string
    versionId?: string
  }>({})
  const [vanityUrl, setVanityUrl] = useState('')
  const [isValidUrl, setIsValidUrl] = useState(false)
  const userData = useCurrentUserRedirectResource()

  const { tree } = useGetTreeById(treeIds)

  const handleVanityUrlChange = (newValue: string, isValidUrl: boolean) => {
    setVanityUrl(newValue)
    setIsValidUrl(isValidUrl)
  }

  const handlePublish = async () => {
    setTreeIds({})
    setVanityUrl('')
    setIsValidUrl(false)
  }

  if (userData.state !== 'hasData') {
    return <Box>Loading...</Box>
  }
  if (!userData.data.roles_list.includes('publisher')) {
    return <Box>You need more auth</Box>
  }

  if (treeIds.treeId && treeIds.versionId && !tree)
    return <Box>Loading Tree...</Box>

  return (
    <Card>
      <CardHeader title="Create New Bundled Curricula" />
      <CardContent>
        <p>
          Are you sure you want to create a new bundled curricula instead of
          updating an existing bundled curricula?
        </p>
        <Box padding={2}>
          {!treeIds.treeId && (
            <TreeIdInput
              onChange={({ treeId, version }) =>
                setTreeIds({ treeId, versionId: version })
              }
            />
          )}
          {tree && (
            <PublishTree
              tree={tree}
              vanityUrl={vanityUrl}
              isValidUrl={isValidUrl}
              onCancel={() => setTreeIds({})}
              onPublish={handlePublish}
              onChange={handleVanityUrlChange}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  )
}
